import * as React from 'react';

import { DropdownView } from 'src/core/ui/dropdown.view';

interface RoleEditorViewProps {
	roleRequest: DropdownRequest<RoleSummary>;
	value: number | null;
	mode: ControlMode;
	onChanged: (number: RoleSummary | null) => void;
	label?: string;
	required?: boolean;
	onGetErrorMessage?: () => Promise<ValidationError[]>;
	afterLoad?: (selectedOptions: any, options: any[]) => void;
}

export class RoleEditorView extends React.Component<RoleEditorViewProps, any> {
	constructor(props) {
		super(props);
	}

	render() {
		let label = this.props.label;
		if (label === undefined) {
			label = 'Role';
		}

		return (
			<DropdownView
				label={label}
				onGetErrorMessage={this.props.onGetErrorMessage}
				disabled={this.props.mode == 'display'}
				onChanged={(item) => { this.props.onChanged(item != null ? item : null) }}
				request={this.props.roleRequest}
				keyField="id"
				textField="displayName"
				required={this.props.required}
				afterLoad={this.props.afterLoad}
				model={this.props.value}
			/>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/general/roles/list/parts/role-editor.view.tsx